export default "__VITE_ASSET__BXX1MWkz__"